import './session';
import Auth from './auth';
import User from './user';
import News from './news';
import Cards from './cards';
import Games from './games';
import Profile from './profile';
import Admin from './admin';
import Bingo from './bingo';

export class ClompApi {
    auth = new Auth();
    user = new User();
    news = new News();
    cards = new Cards();
    games = new Games();
    profile = new Profile();
    admin = new Admin();
    bingo = new Bingo();
}
